import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseCosmeticScanner = lazyWithPreload(
  () => import('./PurchaseCosmeticScanner'),
)
